export { default as component } from "../../../../src/routes/[prefix]/(feature)/staff/+page.svelte";